// extracted by mini-css-extract-plugin
module.exports = {"loderbox":"Loaderstyle_loderbox__ikbxZ","loader-animate":"Loaderstyle_loader-animate__1km_k"};